import {BaseAppPrefs} from "@/shared/BaseAppPrefs";

export class AppPrefs extends BaseAppPrefs {

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }

  static readonly PREF_SELECTED_PRACTICE_ID = "sel_prac_id";

  getSelectedPracticeId(): string | null {
    return this.prefs.getString(AppPrefs.PREF_SELECTED_PRACTICE_ID);
  }

  setSelectedPracticeId(id: string): void {
    this.prefs.setString(AppPrefs.PREF_SELECTED_PRACTICE_ID, id);
  }
}
